import './Skeleton.css';

export function Skeleton({ className = '', style }) {
  return <div className={`skeleton ${className}`} style={style} aria-hidden="true" />;
}

/** Grille de cartes fantômes, utilisée pendant le chargement des services/articles/réalisations. */
export function SkeletonCardGrid({ count = 3 }) {
  return (
    <div className="section__grid section__grid--3" aria-busy="true" aria-live="polite">
      <span className="sr-only">Chargement du contenu...</span>
      {Array.from({ length: count }).map((_, i) => (
        <div className="skeleton-card" key={i}>
          <Skeleton className="skeleton-card__media" />
          <div className="skeleton-card__body">
            <Skeleton className="skeleton-card__tag" />
            <Skeleton className="skeleton-card__title" />
            <Skeleton className="skeleton-card__line" />
            <Skeleton className="skeleton-card__line skeleton-card__line--short" />
          </div>
        </div>
      ))}
    </div>
  );
}

/** Bloc de texte fantôme, utilisé pour les pages de détail (article, service...). */
export function SkeletonText({ lines = 4 }) {
  return (
    <div className="skeleton-text" aria-busy="true" aria-live="polite">
      <span className="sr-only">Chargement du contenu...</span>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className="skeleton-text__line" />
      ))}
    </div>
  );
}
